export const cappedCount = (num: number): string =>
  num >= 1000 ? '1K+' : num.toString();
